export const article = [
  {
    articleId: 13,
    url: "que-es-plan-full-anual",
    category: {
      slug: "comenzar",
      name: "Comenzar"
    },
    title: "¿Qué es Plan Full Anual?",
    content:
      <>
        <div className="row">
          <ul className="disc">
            <li>"Plan Full Anual" corresponde a una modalidad de pago por una suscripción multi-mes de Plan Full de Mega GO, equivalente a 12 meses.</li>
            <li>El precio de este plan equivale a 8 mensualidades del Plan Full mensual (precio lista publicado en megago.cl), y a cambio se reciben 12 meses continuos de suscripción.​</li>
            <li>​Este plan es renovable automáticamente cada 12 meses, si no se ha cancelado la suscripción previamente.​</li>
            <li>​Asimismo, no habrá devolución de dinero si el cliente cancela la suscripción dentro de los 12 meses ya suscritos.​</li>
            <li>
              <u>​Cambio de Plan de pago:</u> El cliente suscrito a Mega GO puede cambiar de modalidad de pago cuando guste (entre mensual y anual), para lo cual tendremos los siguientes casos:
              <ul className="decimal">
                <li><b>Cliente con plan mensual:</b> Si se cambia a plan anual dentro del mes ya facturado, en ese minuto comienza un nuevo ciclo de facturación anual, y al momento de pagar el plan anual se realizará un descuento proporcional a los días restantes del mes ya facturado y pagado previamente.​</li>
                <li><b>Cliente con plan anual:</b> Si se cambia a plan mensual, este comenzará su cobro sólo al finalizar los 12 meses ya pagados de su plan, no importando el momento de la solicitud de cambio dentro de los 12 meses.​</li>
              </ul>
            </li>
          </ul>
        </div>
      </>
  }
];